import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, Modal, Switch, Drawer, Icon } from 'antd'
import moment from 'moment'

import { reviseMerchantType, getReturnDetailStatus, getMerchant } from '_src/api/api'

import AddMerchant from './addMerchant'
// import ReturnDetail from './returnDetail'

import '_src/common/style/common.less' 

import PrevImg from '_src/components/PrevImg/PrevImg'


// const { RangePicker } = DatePicker

const { Search } = Input

const { confirm } = Modal
@Form.create({ name: '' })
class ReturnForm extends Component {
  constructor (props) {
    super(props)
    this.id = '' // 选中商户ID
    // 参数集合
    this.param = {
      storeName: '', // 商铺名称
      merchantName: '', // 商家名称
      mobile: '', // 收货人手机
      // createAt: '', // 申请时间
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      merchant: {},
      //   itemStatus: '',
      //   status: '',
      loading: true,
      visible: false,
      dataList: [],
      statusBtns: [],
    }
  }

  componentDidMount () {
    this.loadData()
    getReturnDetailStatus()
      .then(res=>{
        const { data } = res
        const arr = data.map(item=>{
          item.status = item.status === '总数'? '' : item.status
          return {text: item.status, num: item.count, id: item.status}
        })
        this.setState({
          statusBtns: arr
        })
      })
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, merchantName,storeName , mobile, createAt, createStart, createEnd } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize: 10}
    if (!!merchantName) {
      param = {...param, merchantName}
    }
    if (!!storeName) {
      param = {...param, storeName}
    }
    if (!!mobile) {
      param = {...param, mobile}
    }
    if (!!createAt) {
      param = {...param, createAt}
    }
    if (!!createStart&&!!createEnd) {
      param = {...param, createStart, createEnd}
    }
    // 获取列表信息
    getMerchant(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          return {...item, key: item.id, id: item.id}
        })
        this.setState({
          dataList: dataList,
          loading: false,
          visible: false
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>营业执照</span>,
        align: 'center',
        dataIndex: 'businessLicense',
        key: 'businessLicense',
        render: (_, record) => <div className = "table_btn">
          {
            record.businessLicense
            ?<img src={record.businessLicense} style={{ width: 100, height: 100 }} alt="" onClick={() => this.PrevImg.show(record.businessLicense)} />
            :<Icon type="file-image" style = {{fontSize: 50, color: '#ccc'}} />
          }
        </div>,
      },
      {
        title: <span>商户名称</span>,
        align: 'center',
        dataIndex: 'merchantName',
        key: 'merchantName',
      },
      {
        title: <span>商铺名称</span>,
        align: 'center',
        dataIndex: 'storeName',
      },
      {
        title: <span>账号</span>,
        align: 'center',
        dataIndex: 'username',
      },     
      {
        title: <span>联系方向</span>,
        align: 'center',
        dataIndex: 'mobile',
      },
     
      {
        title: <span>创建时间</span>,
        align: 'center',
        dataIndex: 'createAt',
        
      },
      {
        title: <span>商家状态</span>,
        align: 'center',
        dataIndex: 'status',
        render: (status, _, index) => (
          <Switch checkedChildren="有效"
            unCheckedChildren="无效" 
            checked = {!!status}
            onClick = { (checked) => { this.handleSwitch(checked, index) }}
          />
        )
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div className = "table_btn">
          <Button type = "link" icon="eye" style={{marginRight: '10px'}} onClick = { () => { this.linkTo(`/system/merchant/detail?id=${record.id}`) } } >查看</Button>
          <Button type = "link" icon="form" style={{marginRight: '10px', color: '#228234'}} onClick = { () => { this.openDrawer(record) } } >修改</Button>
        </div>,
      },
    ]
  }

  // 商家状态切换
  handleSwitch = (checked, index) => {
    const _self = this
    const { dataList } = this.state
    const list = [...dataList]
    const { merchantName, id } = list[index]
    confirm({
      title: '温馨提示',
      content: (
        <p>你确定要将
          <strong style = {{color: '#000'}}> {merchantName}</strong> 切换至 <strong style = {{color: 'red'}}>{checked?'有效':'无效'}</strong> 吗？
        </p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        reviseMerchantType(id)
          .then(()=>{
            list[index].status = checked 
            _self.setState(()=>({
              dataList: list
            }))
          })
      },
      onCancel () {
      },
    })
  }
  // 关闭抽屉
  onClose = () => {
    this.setState({
      visible: false
    })
  }

  // 打开抽屉
  /**
   * @param{type:1->查看,2->修改，3->添加}
  */
  openDrawer = (record) => {
    record= record || {}
    this.setState(()=>({
      visible: true,
      merchant: record
    }), ()=>{
    })
  }
  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  // 时间搜索
  handleDateSearch = (key, _, dateString) => {
    this.param[key] = dateString
    this.param.pageNum = 0
    this.loadData()
  }
  timerChange = (e) => {
    this.param.pageNum = 0
    
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    this.loadData()
  }
  linkTo (url) {
    this.props.history.push(url)
  }
  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.param.pageNum = 0
     
      this.loadData()
    })
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, loading, visible, merchant } = this.state
    const { merchantName } = merchant
    const { pageNum, totalElements } = this.param
    // const statusBtns = [
    //   {text: '全部申请', num: this.totalElements},
    //   {text: '待处理', num: this.totalElements},
    //   {text: '退货中', num: this.totalElements},
    //   {text: '已完成', num: this.totalElements},
    //   {text: '已拒绝', num: this.totalElements},
    // ]

    const drawerHeader = (
      <div className = "page_top">
        <p className = "page_top_title">
          修改商户-<span style = {{color: 'red'}}>{merchantName}</span>
        </p>
        <div className = "returnDetail_btn">
          <Button className = "" type="primary" onClick = {this.onClose}>
            <Icon type="left" />
            返回
          </Button>
        </div>
      </div>
    )
    return (
      <div className = "ReturnForm page_content" >
        {/* <div className = "top" >
          {
            statusBtns.map((item, index)=>(
              <SearchButton key = {index} id = {item.id} state = {status} handleSearch = {this.handleBtnSearch} label = {item} />
            ))
          }
          
        </div> */}
        
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "商家名称" >
                  <Search placeholder="请输入商户名称" onSearch={(v)=>{ this.handleSearch('merchantName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "店铺名称">
                  <Search placeholder="请输入店铺名称" onSearch={(v)=>{ this.handleSearch('storeName', v) }}enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "手机号">
                  <Search placeholder="请输入手机号" onSearch={(v)=>{ this.handleSearch('mobile', v) }}enterButton />
                </Form.Item>
              </Col>
              {/* <Col span = {8}>
                <Form.Item label = "申请时间">
                  

                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
     
                </Form.Item>
              </Col> */}
            </Row>
          </div>
        </Form>
        
        <Table
          loading = {loading} 
          bordered

          title = {()=>(<Button type = "primary" icon="plus" onClick = { () => { this.linkTo('/system/merchant/add') } }>添加</Button>)}
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Drawer
          title={drawerHeader}
          width={'800'}
          onClose={this.onClose}
          destroyOnClose
          closable = {false}
          visible = {visible}
        >
          <AddMerchant merchant = {merchant} handleLoad = {()=>{
            this.setState(()=>({
              visible: false
            }))
            this.loadData()
          }}
          />
        </Drawer>

        <PrevImg ref={el => this.PrevImg = el} />
        
      </div>
    )
  }
}


export default ReturnForm